import { AxiosError } from 'axios';

export interface ApiError {
  message: string;
  details?: any;
  statusCode?: number;
}

export const getErrorMessage = (error: any): string => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error.response?.data?.errors) {
    const errors = error.response.data.errors;
    if (typeof errors === 'object') {
      return Object.values(errors).flat().join(', ') as string;
    }
    return errors;
  }

  if (error.response?.statusText) {
    return error.response.statusText;
  }

  if (error.message) {
    return error.message;
  }

  return 'An unexpected error occurred';
};

export const handleApiError = (error: AxiosError | any): ApiError => {
  return {
    message: getErrorMessage(error),
    details: error.response?.data,
    statusCode: error.response?.status,
  };
};
